module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/7f43e7d5678caa751c58be63b0dfb4ed.png";